import './chart.style.less'

import {
  AimOutlined,
  BarChartOutlined,
  CalendarOutlined,
  ExpandOutlined,
} from '@ant-design/icons'
import { Button, Dropdown, Input, Menu, Space } from 'antd'
// import { exportChartToImage, exportChartToPdf } from '@/utils/exportChart'
import { capitalize } from 'lodash'
import { useState } from 'react'

interface props {
  title: string
  onPressFullscreen?: () => void
  chartTypes?: any
  id: string
  isTarget?: boolean
  onTarget: (value) => void
  periods: string[]
  onPeriodChange: (period: string) => any
}

function Header(props: props) {
  const {
    title,
    onPressFullscreen = () => {},
    chartTypes,
    // id,
    isTarget,
    onTarget,
    periods,
    onPeriodChange,
  } = props

  const [target, setTarget] = useState<any>()
  const [currentperiod, setcurrentperiod] = useState('monthly')

  // const menu = (
  //   <Menu>
  //     <Menu.Item onClick={() => exportChartToPdf(id)}>Export to PDF</Menu.Item>
  //     <Menu.Item onClick={() => exportChartToImage(id)}>
  //       Export to PNG
  //     </Menu.Item>
  //   </Menu>
  // )

  const menuPeriod = (
    <Menu activeKey={currentperiod}>
      {periods.map((period) => (
        <Menu.Item
          onClick={() => {
            onPeriodChange(period)
            setcurrentperiod(period)
          }}
          key={period}
        >
          {capitalize(period)}
        </Menu.Item>
      ))}
    </Menu>
  )
  return (
    <div className="liveboard-chart-header">
      <div>
        <p className="chart-title">
          {title}
          {/* <Dropdown placement="bottomRight" overlay={menu}>
            <span>
              <Button
                className="more-button"
                type="text"
                shape="default"
                icon={<EllipsisOutlined />}
              />
            </span>
          </Dropdown> */}
        </p>
      </div>
      <Space wrap>
        {isTarget && (
          <Dropdown
            overlay={
              <div className="target-dropdown-overlay">
                <p>Target</p>
                <Input
                  value={target}
                  onChange={(event) => {
                    setTarget(event.target.value)
                    onTarget(event.target.value)
                  }}
                  size="middle"
                />
              </div>
            }
            placement="bottom"
            arrow
          >
            <Button type="default" shape="default" icon={<AimOutlined />} />
          </Dropdown>
        )}
        {chartTypes ? (
          <Dropdown overlay={chartTypes}>
            <div>
              <Button
                type="default"
                shape="default"
                icon={<BarChartOutlined />}
              />
            </div>
          </Dropdown>
        ) : null}
        {periods.length > 0 && (
          <Dropdown overlay={menuPeriod}>
            <Button
              type="default"
              shape="default"
              icon={<CalendarOutlined />}
            />
          </Dropdown>
        )}

        <Button
          onClick={onPressFullscreen}
          type="default"
          shape="default"
          icon={<ExpandOutlined />}
        />
      </Space>
    </div>
  )
}
export default Header
